import React, { useState, useRef } from "react";
import produce from 'immer';
import auth from "../auth";
import Version from "version";
import * as rdd from 'react-device-detect';
import useWindowDimensions from "../hooks/useWindowDimensions";
import { useTranslation } from 'react-i18next';
import { useConnect } from 'dotnetify';
import globalState from '../state/GlobalState';
import { useTheme } from '@material-ui/core/styles';
import { useState as globalUseState } from '@hookstate/core';
import ServerState from '../controls/ServerState';
import ToggleButton from 'react-toggle-button';
import { ActionBox } from '../controls/ActionBox';
import { Grid, Divider } from '@material-ui/core';
import { Link } from 'react-tiger-transition';
import LeftChevronIcon from '../assets/img/svg/left-chevron.svg';
import SparkleDialog from '../controls/components/SparkleDialog';
import PrepaidContainer from '../controls/PrepaidContainer';
import PotContainer from '../controls/PotContainer';
import { Box, BoxTitle, BoxContent } from '../controls/Box';
import { LargeButton, SmallButton } from '../controls/components/Buttons';


export default function Subscription() {
    const { t } = useTranslation();
    const getParameterByName = (name) => {
        var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    };
    const { state, vm } = useConnect("Subscription", {}, {
        headers: {
            Authorization: "Bearer " + auth.getAccessToken(),
            ClientVersion: Version.getVersion(),
            ServerToken: window.sessionStorage.ServerToken
        },
        vmArg: { SubscriptionNo: getParameterByName('subscriptionno') },
        exceptionHandler: _ => auth.signOut()
    });
    const [localState, internalSetLocalState] = useState({ disabled: false, busy: false, showBuyDataButton: false, dialogOpen: false });
    const setLocalState = (o) => {
        internalSetLocalState(
            produce(draft => {
                draft[Object.keys(o)[0]] = Object.values(o)[0];
            })
        )
    }
    const dialogRef = useRef();
    const handleOpenPostpaidTopupDialog = () => {
        dialogRef.current.showDialog("postpaidTopup");
    }
    const handleOpenPrepaidTopupDialog = () => {
        dialogRef.current.showDialog("prepaidTopup");
    }
    const handleOpenChargePrepaidDialog = () => {
        dialogRef.current.showDialog("chargePrepaid");
    }
    const handleChangeDataLevel = () => {
        dialogRef.current.showDialog("changeSubscriptionDataLevel");
    }
    const handleRefresh = () => {
        vm.$dispatch({ Refresh: true });
    }
    const gstate = globalUseState(globalState);
    const theme = useTheme();
    const wDim = useWindowDimensions();
    return (
        <>
            <ServerState serverState={state} localState={localState} setLocalState={setLocalState} />
            <SparkleDialog ref={dialogRef} handleRefresh={handleRefresh} subscriptionNo={state.SubscriptionNo} />
            <div className="noselect" style={{ overflowY: rdd.isFirefox ? 'auto' : wDim.desktop ? 'overlay' : 'scroll', maxHeight: '100%' }}>
                <div style={{ maxWidth: wDim.desktop ? '720px' : 'unset', width: '100%', padding: wDim.width <= 320 ? '35px 7px' : '35px 17px' }}>
                    <div><Link id="back" replace to={gstate.topModuleUrl.get() ? gstate.topModuleUrl.get() : '/home'} transition="glide-right" style={{ textDecoration: 'none', fontSize: '14px', fontFamily: theme.typography.fontFamily2, fontWeight: 300 }}><img src={LeftChevronIcon} height="32" alt="" style={{ marginTop: '-5px', marginRight: '-6px' }} /><div style={{ verticalAlign: 'top', marginTop: '2px', color: theme.palette.primary.main, display: 'inline-block' }}>{gstate.topModuleName.get()}</div></Link></div>
                    <Grid container direction="column" justify="center" alignItems="center">
                        {/*<div style={{ fontSize: '16px', marginBottom: '10px' }}>{state.Title}</div>*/}
                        {state.IsAdministrating &&
                            <>
                                <ToggleButton
                                    colors={{
                                        active: {
                                            base: theme.palette.primary.main,
                                        },
                                    }}
                                    containerStyle={{ display: 'inline-block', width: '150px', height: '40px' }} trackStyle={{ width: '160px', borderRadius: 2, height: '40px' }} thumbStyle={{ borderRadius: 2, width: '38px', height: '38px' }} thumbAnimateRange={[1, 120]} activeLabelStyle={{ width: '100px', fontSize: '14px', left: '20px', fontFamily: theme.typography.fontFamily }} inactiveLabelStyle={{ width: '100px', fontSize: '14px', fontFamily: theme.typography.fontFamily }}
                                    inactiveLabel={"Bruker"}
                                    activeLabel={"Administrator"}
                                    value={state.subscription?.IsAdmin}
                                    onToggle={(value) => {
                                        vm.$dispatch({ ChangeAdmin: !value });
                                    }} />
                                <div style={{ marginTop: '20px', width: '100%' }}></div>
                                {(state.subscription?.IsPostpaid || state.subscription?.IsData) &&
                                    <PotContainer Pots={state.subscription?.Pots} vm={vm} state={state} localState={localState} setLocalState={setLocalState} handleBuyData={handleOpenPostpaidTopupDialog} handleChangeDataLevel={handleChangeDataLevel} />}
                                {state.subscription?.IsPrepaid &&
                                    <PrepaidContainer state={state} handleBuyData={handleOpenPrepaidTopupDialog} handleChargePrepaid={handleOpenChargePrepaidDialog} />
                                }
                            </>
                        }
                    </Grid>
                    {state.subscription &&
                        <Grid container direction="column" justify="center" alignItems="center" style={{ paddingTop: '17px' }}>
                            <Box border>
                                <BoxTitle>{state.IsNorway ? 'Kontaktinformasjon' : 'Kontaktinformation'}</BoxTitle>
                                <Grid container direction="row" justify="space-between" alignItems="center">
                                    <Grid item>
                                        <BoxContent>
                                            <div>
                                                <span dangerouslySetInnerHTML={{ __html: state.ContactInfo }} />
                                            </div>
                                        </BoxContent>
                                    </Grid>
                                    <Grid item>
                                        <Grid container direction="column" justify="space-between" alignItems="center">
                                            <SmallButton onClick={() => { dialogRef.current.showDialog('changeUser'); }}>{t('button.change')}</SmallButton>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    }
                    {state.subscription ?
                        <Grid container direction="row" justify="space-between" alignItems="flex-start">
                            <Grid item style={{ width: wDim.desktop ? '47%' : '100%' }}>
                                <div style={{ color: theme.palette.primary.main, margin: '10px' }}>{state.IsNorway ? 'Handlinger' : 'Åtgärder'}</div>
                                {state.subscription?.CanActivateSimcard &&
                                    <ActionBox
                                        title={t('selfcare:item.activatesim')}
                                        subTitle={t('selfcare:item.receivedsimcard')}
                                        icon="simcard"
                                        buttonText={state.IsNorway ? "Aktiver" : "Aktivera"}
                                        action={() => { dialogRef.current.showDialog('activateSimcard'); }}
                                    />
                                }
                                {state.subscription?.CanChangePackage &&
                                    <ActionBox
                                        title={state.IsSweden ? t('selfcare:item.change-subscription-type-swe') : t('selfcare:item.changesubscription', { 0: `${state.subscription?.Type}` })}
                                        subTitle={state.subscription?.OpenOrder ? t('selfcare:item.orderbeingprocessed', { 0: state.subscription?.PackageDescription }) : state.subscription?.PackageDescription}
                                        icon="money"
                                        buttonText={state.IsNorway ? "Endre" : "Byt"}
                                        action={() => { dialogRef.current.showDialog('changeSubscription'); }}
                                    />
                                }
                                {state.subscription?.CanChangeDataLevel &&
                                    <ActionBox
                                        title="Endre datagrense"
                                        subTitle={state.subscription?.OpenOrder ? t('selfcare:item.orderbeingprocessed', { 0: state.subscription?.TotalData }) : state.subscription?.TotalData}
                                        icon="money"
                                        buttonText={state.IsNorway ? "Endre" : "Byt"}
                                        action={() => { dialogRef.current.showDialog('changeSubscriptionDataLevel'); }}
                                    />
                                }
                                <ActionBox
                                    title={t('selfcare:item.pinslashpuk')}
                                    subTitle={t('selfcare:item.showpinandpuk')}
                                    icon="pin"
                                    buttonText={state.IsNorway ? "Vis" : "Visa"}
                                    action={() => { dialogRef.current.showDialog('viewPinPuk'); }}
                                />
                                <ActionBox
                                    title={t('selfcare:item.blockunlocksim')}
                                    subTitle={t('selfcare:item.lostphone')}
                                    icon="block-sim"
                                    buttonText={state.IsNorway ? "Administrer" : "Hantera"}
                                    action={() => { dialogRef.current.showDialog('blocking'); }}
                                />
                                <ActionBox
                                    title={state.subscription?.SimCardOrderOpen ? t('selfcare:item.ordernewsimprocessed') : t('selfcare:item.ordernewsim')}
                                    subTitle={t('selfcare:item.neednewsim')}
                                    icon="simcard"
                                    buttonText={state.IsNorway ? "Bestill" : "Beställ"}
                                    action={() => { dialogRef.current.showDialog('orderSimcard'); }}
                                />
                                {state.IsAdmin && !state.IsAdministrating &&
                                    <ActionBox
                                        title={state.subscription?.IsPostpaid ? t('selfcare:item.invoicerecipient') : t('selfcare:item.owner')}
                                        subTitle={t('selfcare:item.newadress')}
                                        icon="profile"
                                        buttonText={state.IsNorway ? "Endre" : "Ändra"}
                                        action={() => { dialogRef.current.showDialog('changeAddress'); }}
                                    />
                                }
                                {state.IsSweden && !state.IsAdministrating &&
                                    <>
                                        <ActionBox
                                            title="Betalmetod - Faktura eller Betalkort"
                                            subTitle="Byt betalmetod"
                                            icon="invoice"
                                            buttonText="Byt"
                                            action={() => { dialogRef.current.showDialog('changePaymentMethod'); }}
                                        />
                                        {state.subscription?.PaymentMethod === 'credit-card' &&
                                            <ActionBox
                                                title="Betalkort"
                                                subTitle="Se och ändra betalkort"
                                                icon="credit-card"
                                                buttonText="Ändra"
                                                action={() => { dialogRef.current.showDialog('changePaymentCard'); }}
                                            />
                                        }
                                        <ActionBox
                                            title="Chili kompisar"
                                            subTitle="Värva Kompisar och få rabatt"
                                            icon="friends"
                                            buttonText="Visa"
                                            action={() => { dialogRef.current.showDialog('viewFriends'); }}
                                        />
                                    </>
                                }
                            </Grid>
                            <Grid item style={{ width: wDim.desktop ? '47%' : '100%' }}>
                                {state.subscription?.ActiveServices && state.subscription?.ActiveServices.length > 0 &&
                                    <div id="services" style={{ color: theme.palette.primary.main, margin: '10px' }}>{state.IsNorway ? 'Aktive tjenester' : 'Aktiva tjänster'}</div>}
                                {state.subscription?.ActiveServices && state.subscription?.ActiveServices.length > 0 ? state.subscription?.ActiveServices.map((service) => {
                                    return (
                                        <div key={service.ServiceNo}>
                                            <ActionBox
                                                title={service.Name}
                                                subTitle={service.Status}
                                                icon={service.Image}
                                                buttonText={state.IsNorway ? "Administrer" : "Hantera"}
                                                action={() => { sessionStorage.ServiceNo = service.ServiceNo; sessionStorage.GroupId = service.GroupId; dialogRef.current.showDialog('changeService'); }}
                                            />
                                        </div>
                                    );
                                }) : null}

                                {state.subscription?.OtherServices && state.subscription?.OtherServices.length > 0 &&
                                    <div style={{ color: theme.palette.primary.main, margin: '10px' }}>{state.IsNorway ? 'Andre tjenester' : 'Andra tjänster'}</div>}
                                {state.subscription?.OtherServices && state.subscription?.OtherServices.length > 0 ? state.subscription?.OtherServices.map((service) => {
                                    return (
                                        <div key={service.ServiceNo}>
                                            <ActionBox
                                                title={service.Name}
                                                subTitle={service.Status}
                                                icon={service.Image}
                                                buttonText={state.IsNorway ? "Administrer" : "Hantera"}
                                                action={() => { sessionStorage.ServiceNo = service.ServiceNo; sessionStorage.GroupId = service.GroupId; dialogRef.current.showDialog('changeService'); }}
                                            />
                                        </div>
                                    );
                                }) : null}

                            </Grid>
                        </Grid>
                        :
                        <div id="preloader">
                            <div id="loader"></div>
                        </div>
                    }
                </div>
                {!wDim.desktop && <div style={{ width: '100%', height: '92px' }} />}
            </div>
        </>
    );
}